import React, { FC } from 'react';
import { Text, View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { ProductionBatchStatistics } from '@interfaces/search';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';

interface BatchEventsChangeProps extends NavigationProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
}

const BatchEventsChangeComponent: FC<BatchEventsChangeProps> = ({ lg, batch }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL), flex: 1, }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.CHANGE, productionBatchId: batch.data?.productionBatchId }} />
      </View>
    </MachinesProvider>
  );
};

const BatchEventsChange = connect(({ batch: { batch } }) => ({ batch }), {})(BatchEventsChangeComponent);

export { BatchEventsChange };
